import styled from "@emotion/styled";
import { Tag } from "@snapchat/snap-design-system";

interface DetailsTagProps {
    color: string;
}

export const DetailsTag = styled(Tag)<DetailsTagProps>`
    margin: 4px 10px 0 0;
    padding: 4px 8px;
    ${({ color }) => (color ? `background-color: ${color};` : null)}
    ${({ color }) => (color ? `border-color: ${color};` : null)}
`;
